<template>
  <bvue-ui-view class="flex flex-col w-full" :scroll="true">
    <h1 class="flex-1">Ecosistema</h1>
    <div class="form-group flex-1">
      <label>Nombre</label>
      <input type="text" class="form-input" v-model="item.name">
    </div>
    <div class="form-group flex-1">
      <label>Nombre_us</label>
      <input type="text" class="form-input" v-model="item.name_us">
    </div>
    <div class="form-group flex-1">
      <label>Nombre_de</label>
      <input type="text" class="form-input" v-model="item.name_de">
    </div>
    <div class="form-group flex-1">
      <label>Descripción</label>
      <textarea name="description" class="form-input" v-model="item.description"></textarea>
    </div>
    <div class="form-group flex-1">
      <label>Descripción_us</label>
      <textarea name="description_us" class="form-input" v-model="item.description_us"></textarea>
    </div>
    <div class="form-group flex-1">
      <label>Descripción_de</label>
      <textarea name="description_de" class="form-input" v-model="item.description_de"></textarea>
    </div>
    <div class=" flex my-4 justify-end">
      <div>
        <button @click="store" :class="['btn', 'btn-primary', loading]">{{isNew ? 'Crear' : 'Guardar'}}</button>
      </div>
    </div>
  </bvue-ui-view>
</template>

<script>
import firebase from '@/firebase'
export default {
  name: 'SpecieDetails',
  components: {  },
  props: {
    modalData: Object
  },
  data() {
    return {
      isNew: true,
      loading: [],
      item: {}
    }
  },
  methods: {
    async store() {
      this.loading = ['loading', 'disabled']
      const collection = firebase.firestore.collection('ecosystems')
      var item = this.item
      const id = this.item.id
      delete item.id
      await collection.doc(id).set(item)
      this.loading = []
      this.$bvueUi.modal.close()
    }
  },
  created() {
    console.log('this.modalData: ', this.modalData)
    if (this.modalData && this.modalData.id) {
      this.isNew = false
      this.item = this.modalData
    } else {
      this.item.id = firebase.firestore.collection('ecosystems').doc().id
    }
    console.log('this.item: ', this.item)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/EcosystemDetails.vue